'use strict';

import MyApi from '@api/company/new_users';

import { getStorageData } from "@/utils/storage";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::companies::users::default]';

const getUsers = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const company = getStorageData("company");
    const response = await MyApi.getUsers(company.id);
    return response.data;
}

export default {
    getUsers
};